import { medicalPatient, officeAsset, retailExhibition } from '@pages/Enterprise/Solution/components/Banner/BannerImages';
import productImg from '../main/product/productImg';
import productPurchase from '../main/product/productPurchase';
import video from '@src/assets/images/solution/manufacturingProcess/video/rtlsVideo.mp4';

export default {
  desc: 'Smart Factory ( Nhà máy thông minh )  là những nhà máy sử dụng công nghệ IoT và Trí tuệ nhân tạo (AI) để tự động hóa và tối ưu hóa dây chuyền sản xuất. Điều này góp phần nâng cao hiệu quả của quy trình sản xuất, giảm thời gian bảo trì, và cải thiện sản lượng cũng như chất lượng sản phẩm.',
  keywords: 'Smart Factory, Nhà máy thông minh, Nha may thong minh, Digital Twin, Theo dõi vị trí, Theodoi vitri',
  ogSite: 'Smart Factory là gì?',
  title: 'Smart Factory là gì?',
  ogUrl: 'https://orbro.io/vi/blog/smartFactory',
  ogImg:
    'https://lh3.googleusercontent.com/fife/AGXqzDlrNJZcN0y8rqN6rn4lIBsYzyCBFCLngoMNzRGAY6aBK05F5A7p7wMg7ZuILGtqR0GyG3qa5nWoqrTkhzMc8RRj0tMC2erUg8B95SfXjNpxqhWAlZI2ZNQ20zf6Bqvfx3ztoqtHXcz2hhYcN11wxSut__qBoWsflYyVOeQHJ35WsxS_wN8WaNJKzx-dhLVFusRshtRF7Zx4doNUOlm_KUYkgX0IUQ1IeB6yFe3WYvOyZC8sqY1FMnRAfO22PRRK4uVETtZYRhz1rrYA_xT7mbQP94D71TrIFaoebXtygq-yfvQOvJ4UfR6wr4I2M4V0oN6suppqQ8YAOYRD1WYR_cbQeuw_KsCJ2wLvHZYc2LaJwaDpP3CO-Ygqw0gsMrOMEtf5U1WEMf903qg20rF0D8hqpBPnjJRCQ6KY2leZG3Xv2k7q5gSOcKTnqSEQTe7DpWKAbnscWRoK7j1HGIopA0MWEyVIu5Ux9VhBZUSMEgfQkKoAX2UL71HTDwV7xf_AMP2cVdj7u49LCN1Pcdq-eKXMygl_EcCyGvoZ_wp4Bq7Uh1dbm7IJe5A2TaDKbuzgY9JL-ZFhxhwVES7tvZlWP-B_TeatTd2RKPQ6FMoeblJYuiAjHopqXL9JO8-y5wEcVgWwSo6_2W1AosdLSjlS2dqAE827GZP9HjudpoEd7lQXyP3bdXE6n3DzSuUOtextrsHpP6vN6tZ7q6krYTztpHpdIN8naMIOpdy4O2pdvv1uz-fhax_TyYVUEXg6ld7JVk-hPSvGPIAVUDpUx00G4uQgiBq8U0EZlVtIPynqiSn0VJjVTkArpnM_WX3E05A4Qwt-1AS3SagPFHUABELaSJyL1L34cKVxK_BLvKBZlGnfpC1LqOfmjS5iBamKqpm4ctvMkBIwLKcxad4eYpEH1H_yQ9AxantgCTB-GHWAdLrVk0cA3jMjJfx-OpQRCUEE2BSLWbuTCDEtJpMFwRzLdHzcRjg8qbJgjJTV7KeVZCHqn9DoghaNW2r_ON-IXwyfgNGPNPqeGx81epFjGIdFEjaCGAgIGdsth-CUeTGc5Q69DrT_PAuAYnbN3F7Bj1XLyz0Ie97ogOtcAHLzQwCjNd0Ll1vl2A35yNX905gQEctPSAY9e91nlTtH6KmIgLYgtpBt-w4xOQIXh4_z5hZulvwYKL2lh7Xt-qXqpV-PGYYbnGgz20mwGck4DxmCnXztmOUOMWkwvZ6BFpIoA7ZA2EntRJ8Z6hI17yexqq-384ja6SLh_3QqtEALCOtwyxIYCqwJsSFPyGPp17Pz1RyvB-j2RZ23GCX1YKYo6STGlKOmlYxmV0spVQQIQVgamCYHkKTDfSr3KFe2-SyaJEaPRoIansSf_NTtNvwC8RD0AMr2HYs7iQ35mFLUS5KF2dTLlah-AmnppP4WbuZ-4T0McWZKlfAFjR_nLifHSgTF8XTBEa9XMQsjhzP3c_SWzbqMOkYR82Q9zVg6wacsuo537pPMZn5oxZcSFNdLKsmywtFpS9Pg5dWlyWI7fgd7sn-lu7-vhp8j6iz36SG2OsnjAuOrlL92W_P9=w1984-h1208',
  ogType: 'website',
  date: '2024-01-12',
  tag1: '#Theodoivitri',
  tag2: '#Nhamaythongminh',
  tag3: '#DigitalTwin',
  tag4: '#SmartFactory',
  text: [
    {
      head: 'Smart Factory là gì?',
      subHead: '',
      desc: 'Smart Factory ( Nhà máy thông minh )  là những nhà máy sử dụng công nghệ IoT và Trí tuệ nhân tạo (AI) để tự động hóa và tối ưu hóa dây chuyền sản xuất. Điều này góp phần nâng cao hiệu quả của quy trình sản xuất, giảm thời gian bảo trì, và cải thiện sản lượng cũng như chất lượng sản phẩm. Nó đổi mới khái niệm về ngành sản xuất truyền thống, giúp cắt giảm chi phí phát sinh trong quá trình sản xuất và nâng cao chất lượng sản phẩm.\nSmart Factory đang là phương thức sản xuất đổi mới được nhân rộng nhanh chóng trong ngành sản xuất hiện đại, thu hút sự chú ý nhờ khả năng sử dụng hiệu quả công nghệ Digital Twin và theo dõi vị trí để nâng cao năng suất và tối ưu hóa quy trình sản xuất.',
      dot: '',
    },
    {
      head: 'Các chức năng của Smart Factory',
      subHead: '',
      desc: 'Smart Factory tập trung vào việc tích hợp nhiều công nghệ và hệ thống khác nhau để quản lý và tối ưu hóa quy trình sản xuất một cách thông minh. Thông qua đó, có thể nâng cao năng suất, cắt giảm chi phí và cải thiện chất lượng. Các chức năng chính của Smart Factory bao gồm:',
      dot: '',
    },
    {
      head: '',
      subHead: 'Tự động hóa và Công nghệ Robot',
      desc: 'Smart Factory áp dụng các robot tiên tiến và hệ thống tự động hóa để tự động hóa các công việc trên dây chuyền sản xuất. Điều này góp phần cắt giảm chi phí lao động và nâng cao năng suất.',
      dot: '',
    },
    {
      head: '',
      subHead: 'Công nghệ Digital Twin',
      desc: 'Tạo ra Digital Twin của sản phẩm hoặc quy trình sản xuất, mô hình hóa các đối tượng vật lý trong thế giới thực vào môi trường kỹ thuật số. Thông qua đó, có thể giám sát và tối ưu hóa quy trình sản xuất theo thời gian thực.',
      dot: '',
    },
    {
      head: '',
      subHead: 'Công nghệ Internet vạn vật (IoT)',
      desc: 'Sử dụng các thiết bị IoT được kết nối với cảm biến để kết nối tất cả các thiết bị và máy móc trên dây chuyền sản xuất vào mạng lưới. Nhờ đó, có thể thu thập dữ liệu theo thời gian thực và giám sát quy trình sản xuất để quản lý hiệu quả.',
      dot: '',
    },
    {
      head: '',
      subHead: 'Công nghệ Theo dõi vị trí',
      desc: 'Ứng dụng các công nghệ theo dõi vị trí như RFID hoặc GPS để theo dõi vị trí của nguyên vật liệu, sản phẩm, công nhân, v.v., theo thời gian thực. Điều này hỗ trợ quản lý tài nguyên và bố trí công việc hiệu quả trên dây chuyền sản xuất.',
      dot: '',
    },
    {
      head: '',
      subHead: 'Giám sát Môi trường và Hiệu quả Năng lượng',
      desc: 'Smart Factory tập trung vào việc giám sát và giảm thiểu tiêu thụ năng lượng cũng như tác động môi trường phát sinh trong quá trình sản xuất. Nó theo đuổi các phương thức sản xuất thân thiện với môi trường thông qua quản lý bền vững về môi trường.',
      dot: '',
    },
    {
      head: '',
      subHead: 'Điện toán Đám mây (Cloud Computing)',
      desc: 'Lưu trữ và quản lý dữ liệu sản xuất trên đám mây, cho phép truy cập và chia sẻ dữ liệu theo thời gian thực ngay cả từ những địa điểm cách xa về mặt địa lý. Hỗ trợ liền mạch việc cộng tác giữa các địa điểm khác nhau.',
      dot: '',
    },
    {
      head: 'Ưu điểm của Smart Factory',
      subHead: 'Nâng cao Năng suất',
      desc: 'Việc áp dụng tự động hóa và robot hóa giúp tự động hóa các công việc lặp đi lặp lại và thâm dụng lao động, từ đó nâng cao năng suất. Ngoài ra, sử dụng Digital Twin để giám sát và tối ưu hóa quy trình sản xuất theo thời gian thực cũng giúp nâng cao hiệu quả sản xuất.',
      dot: '',
    },
    {
      head: '',
      subHead: 'Cải thiện Chất lượng',
      desc: 'Bằng cách sử dụng cảm biến và công nghệ IoT để thu thập và phân tích dữ liệu phát sinh trên dây chuyền sản xuất, quy trình sản xuất sản phẩm được giám sát. Điều này giúp giảm tỷ lệ lỗi và cải thiện chất lượng sản phẩm.',
      dot: '',
    },
    {
      head: '',
      subHead: 'Giảm Chi phí',
      desc: 'Áp dụng hệ thống tự động hóa giúp cắt giảm chi phí lao động, và thực hiện bảo trì dự đoán thông qua phân tích Big Data giúp giảm thiểu chi phí bảo trì. Ngoài ra, tối ưu hóa quy trình sản xuất cũng giúp tăng hiệu quả sử dụng tài nguyên, từ đó cắt giảm chi phí.',
      dot: '',
    },
    {
      head: '',
      subHead: 'Tính linh hoạt và Khả năng ứng phó nhanh với thay đổi',
      desc: 'Thông qua Digital Twin và hệ thống sản xuất thông minh, dây chuyền sản xuất có thể được điều chỉnh và thay đổi linh hoạt hơn. Điều này mang lại khả năng nhanh chóng thiết lập hoặc sửa đổi dây chuyền sản xuất cho các loại sản phẩm khác nhau.',
      dot: '',
    },
    {
      head: '',
      subHead: 'Giám sát theo thời gian thực và Ra quyết định',
      desc: 'Dữ liệu môi trường sản xuất được thu thập theo thời gian thực thông qua dữ liệu cảm biến và công nghệ IoT, sau đó được phân tích nhanh chóng bằng cách sử dụng phân tích Big Data và công nghệ AI. Điều này cho phép nắm bắt trạng thái của dây chuyền sản xuất theo thời gian thực và đưa ra quyết định nhanh chóng.',
      dot: '',
    },
    {
      head: '',
      subHead: 'Hiệu quả Tài nguyên',
      desc: 'Smart Factory áp dụng các phương thức sản xuất tiết kiệm năng lượng để giảm thiểu tiêu thụ năng lượng, đồng thời sử dụng Big Data và AI để giám sát và tối ưu hóa việc sử dụng tài nguyên hiệu quả.',
      dot: '',
    },
    {
      head: '',
      subHead: 'Sản xuất Thân thiện với Môi trường',
      desc: 'Thiết kế thân thiện với môi trường của quy trình sản xuất và các phương thức sản xuất tiết kiệm năng lượng giúp tạo ra một môi trường sản xuất thân thiện với môi trường. Điều này góp phần nâng cao tính bền vững của doanh nghiệp và giảm thiểu tác động đến môi trường.',
      dot: '',
    },
    {
      head: 'Các ví dụ trường hợp về Smart Factory',
      subHead: 'Toyota',
      desc: 'Toyota được coi là người đi đầu trong sản xuất thông minh. Họ tích cực áp dụng các công nghệ tiên tiến như Digital Twin, robot và AI để đổi mới quy trình sản xuất. Ví dụ, robot tiên tiến cùng tồn tại và thực hiện công việc với công nhân, đồng thời sử dụng Digital Twin để giám sát và tối ưu hóa quy trình sản xuất theo thời gian thực.',
      dot: '',
    },
    {
      head: '',
      subHead: 'Smart Factory Bosch',
      desc: 'Bosch đang xây dựng các Smart Factory trong lĩnh vực công nghệ ô tô và công nghiệp. Họ tích hợp Digital Twin và IoT để tối ưu hóa quy trình sản xuất, đồng thời sử dụng công nghệ theo dõi vị trí để theo dõi và quản lý hiệu quả sự di chuyển của nguyên vật liệu và sản phẩm theo thời gian thực.',
      dot: '',
    },
    {
      head: '',
      subHead: 'Cơ sở sản xuất thông minh GE',
      desc: 'GE, hoạt động trong nhiều lĩnh vực khác nhau như điện lực, năng lượng tái tạo và chăm sóc sức khỏe, đang tích cực áp dụng công nghệ sản xuất thông minh. Họ sử dụng Digital Twin và IoT để giám sát trạng thái thiết bị sản xuất, đồng thời thực hiện bảo trì dự đoán thông qua phân tích Big Data để tối đa hóa hiệu quả sản xuất.',
      dot: '',
    },
    {
      head: 'Phương pháp xây dựng Smart Factory',
      subHead: '1. Xây dựng Tầm nhìn và Lập kế hoạch Chiến lược',
      desc: 'Trước khi xây dựng Smart Factory, doanh nghiệp cần thiết lập tầm nhìn và lập kế hoạch chiến lược cho Smart Factory. Xác định rõ ràng những công nghệ nào sẽ được áp dụng và những mục tiêu nào cần đạt được.',
      dot: '',
    },
    {
      head: '',
      subHead: '2. Phân tích Hiện trạng và Xác định Yêu cầu',
      desc: 'Phân tích hệ thống sản xuất và trình độ công nghệ hiện tại, đồng thời xác định các yêu cầu cần thiết cho việc triển khai Smart Factory. Nắm bắt điểm mạnh và điểm yếu của quy trình sản xuất và xác định các phần cần cải thiện.',
      dot: '',
    },
    {
      head: '',
      subHead: '3. Lựa chọn và Tích hợp Công nghệ',
      desc: 'Lựa chọn các công nghệ sẽ được áp dụng để cấu thành Smart Factory từ Digital Twin, IoT, phân tích Big Data, AI, tự động hóa, v.v. Sau đó, xây dựng một hệ thống có thể tích hợp và sử dụng hiệu quả các công nghệ này.',
      dot: '',
    },
    {
      head: '',
      subHead: '4. Áp dụng Tự động hóa và Robot hóa',
      desc: 'Tự động hóa một phần hoặc toàn bộ dây chuyền sản xuất và giới thiệu robot để tự động thực hiện các công việc thâm dụng lao động. Điều này nhằm nâng cao năng suất và... (đoạn văn bản gốc bị cắt cụt).',
      dot: '',
    },
    {
      head: '',
      subHead: '5. Xây dựng Digital Twin',
      desc: 'Tạo ra Digital Twin của sản phẩm hoặc quy trình sản xuất. Digital Twin được sử dụng để nhân bản kỹ thuật số các đối tượng vật lý hoặc quy trình trong thế giới thực nhằm mục đích giám sát và tối ưu hóa.',
      dot: '',
    },
    {
      head: '',
      subHead: '6. Áp dụng Công nghệ Internet vạn vật (IoT)',
      desc: 'Áp dụng cảm biến và công nghệ IoT để kết nối tất cả các thiết bị và máy móc trên dây chuyền sản xuất, thu thập dữ liệu theo thời gian thực. Điều này cho phép giám sát và tối ưu hóa quy trình sản xuất.',
      dot: '',
    },
    {
      head: '',
      subHead: '7. Áp dụng Công nghệ Theo dõi vị trí',
      desc: 'Áp dụng các công nghệ theo dõi vị trí như RFID, GPS, UWB RTLS để theo dõi vị trí của sản phẩm, tài nguyên, và công nhân theo thời gian thực, đồng thời thực hiện bố trí tài nguyên tối ưu.',
      dot: '',
    },
    {
      head: '',
      subHead: '8. Ứng dụng Big Data và Trí tuệ nhân tạo (AI)',
      desc: 'Sử dụng công nghệ Big Data để thu thập và phân tích dữ liệu sản xuất, đồng thời sử dụng AI để tìm kiếm các mẫu trong dữ liệu và thực hiện phân tích dự đoán. Điều này giúp tối ưu hóa quy trình sản xuất và tiến hành bảo trì dự đoán.',
      dot: '',
    },
    {
      head: '',
      subHead: '9. Áp dụng Điện toán Đám mây (Cloud Computing)',
      desc: 'Lưu trữ và xử lý dữ liệu sản xuất trên đám mây để có thể truy cập dữ liệu theo thời gian thực và giám sát tập trung từ xa.',
      dot: '',
    },
    {
      head: '',
      subHead: '10. Tăng cường Bảo mật',
      desc: 'Trong Smart Factory, nhiều dữ liệu được trao đổi, do đó bảo mật rất quan trọng. Áp dụng hệ thống bảo mật phù hợp để đảm bảo tính toàn vẹn và bảo mật của dữ liệu.',
      dot: '',
    },
    {
      head: '',
      subHead: '11. Đào tạo và Cải thiện Hạ tầng',
      desc: 'Tiến hành đào tạo nhân viên để họ có thể sử dụng hiệu quả các công nghệ và hệ thống mới. Ngoài ra, cải thiện hạ tầng nếu cần thiết để hỗ trợ việc xây dựng Smart Factory.',
      dot: '',
    },
  ],

  link: {
    page: 'rtls',
    numb: '2',
    product: [
      {
        text: productPurchase.purchase.worker.workerTracking.title,
        title: productPurchase.purchase.worker.workerTracking.title,
        serial: productPurchase.purchase.worker.workerTracking.serial,
        desc: 'Sản phẩm này giúp gắn thiết bị UWB lên nhân viên hoặc thiết bị, hỗ trợ theo dõi vị trí theo thời gian thực.',
        img: productImg.product.workerTracking.thumbnail,
      },
      {},
    ],
    solution: [
      {
        img: medicalPatient.thumb,
        data: 'medicalPatient',
        link: '/vi/enterprise/medical/patient',
      },
      {
        img: retailExhibition.thumb,
        data: 'retailExhibition',
        link: '/vi/enterprise/retail/exhibition',
      },
      {
        img: officeAsset.thumb,
        data: 'officeAsset',
        link: '/vi/enterprise/office/asset',
      },
    ],
  },
};
